type PartialLocation = Partial<Location> & { hostname: string; host: string };
export const getLocation = (hostname: string): PartialLocation =>
  typeof window !== 'undefined'
    ? window.location
    : {
        hostname,
        host: '[[HOSTNAME]]',
        origin: `https://[[HOSTNAME]]`,
      };
